<template>
  <a-button
    :type="variant"
    :loading="submitting"
    class="aha-antd-button"
    :class="[
      {
        'btn-underline': underline,
        'mr-4': hasMarginRight,
        'ml-4': hasMarginLeft,
        'disabled': disabled,
      },
      `ant-btn-${variant}`,
      `btn-${size}`,
      'ant-btn-custom'
    ]"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <aha-icon
      :name="iconName"
      :height="iconHeight"
      :width="iconHeight"
      :viewBox="iconViewBox"
      :class="iconClasses"
      v-if="iconName.length && !submitting"
    />
    <div v-show="!isLoadingInline || !submitting">
      <slot />
    </div>
  </a-button>
</template>

<script>
import { Button } from 'ant-design-vue'

export default {
  components: {
    'a-button': Button,
  },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'md',
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
    hasMarginRight: {
      type: Boolean,
      default: false,
    },
    hasMarginLeft: {
      type: Boolean,
      default: false,
    },
    underline: {
      type: Boolean,
      default: false,
    },
    iconHeight: {
      type: Number,
      default: 18,
    },
    iconWidth: {
      type: Number,
      default: 20,
    },
    iconViewBox: {
      type: String,
      default: '0 0 24 24',
    },
    iconClasses: {
      type: String,
      default: 'mr-1',
    },
    isLoadingInline: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.aha-antd-button {
  @apply flex justify-center items-center;
}

.ant-btn-custom {
  &.ant-btn-secondary  {
    font-weight: 600;
    &:focus {
      color: inherit;
      border-color: #d9d9d9;
      background-color: inherit;
    }
    &:hover {
      @apply text-brand-a100 border-primary-90;
      background-color: #F2F7FF;
    }
    &:active {
      color: #4F9BF3;
      border-color: #348EF6;
      background-color: #D8E9FD;
    }
    &:focus-visible {
      color: unset;
    border: none;
    }
  }
  &.ant-btn-primary {
    font-weight: 600;
    background-color: #348EF6;
    border: none;
    &:hover {
      background-color: #2E7FDB;
    }
    &:active {
      background-color: #2970C2;
    }
    &.disabled {
      color: #ffffff;
    }
  }
  &.ant-btn-link {
    color: #348EF6;
    &:hover {
      color: #4F9BF3;
    }
    &:active {
      color: #1162C0;
    }
  }
  &.ant-btn-danger {
    font-weight: 600;
    background-color: #D43F48;
    border: none;
    &:hover {
      background-color: #B82A33;
    }
    &:active {
      background-color: #9E242C;
    }
    &.disabled {
      color: #FFFFFF;
      background-color: #E5858B;
    }
  }
  &.ant-btn-tertiary {
    font-weight: 600;
    border: none;
    box-shadow: none;
    background-color: transparent;
    &:hover {
      color: unset;
      background-color: #E0E3ED;
    }
    &:active {
      color: unset;
      background-color: #D4D7E0;
    }
    &:focus {
      color: unset;
    }
    &:focus-visible {
      color: unset;
    }
    &.disabled {
      color: #9D9D9D;
      background-color: transparent;
    }
  }
  &.ant-btn-text {
    border: none;
    box-shadow: none;
    &:hover {
      color: unset;
      background-color: #E0E3ED;
    }
    &:active {
      color: unset;
      background-color: #D4D7E0;
    }
    &:focus {
      color: unset;
    }
    &:focus-visible {
      color: unset;
    }
  }
  &.ant-btn-text-link {
    border: none;
    box-shadow: none;
    color: #191F2D;
    &:hover {
      color: #2E7FDB;
    }
    &:active {
      color: #0F56A8;
    }
    &:focus-visible {
      color: unset;
    }
  }

  &:focus-visible {
    outline: 2px solid;
    outline-offset: 0px;
    outline-color: #89BEFA;
    -moz-outline-radius: 8px;
  }
  .disabled {
    cursor: not-allowed;
  }
  ::v-deep {
    span {
      line-height: 1.5;
    }
  }
}
.btn-underline {
  ::v-deep {
    span {
      text-decoration: underline;
    }
  }
}
.btn-sm {
  height: 28px;
  padding: 4px 8px;
  border-radius: 4px;

  &.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {
    padding-left: 20px;
  }
}
.btn-md {
  height: 36px;
  padding: 8px 16px;
  border-radius: 8px;
}
.btn-lg {
  height: 44px;
  padding: 12px 20px;
  border-radius: 8px;
}
.btn-xl {
  height: 52px;
  padding: 12px 20px;
  border-radius: 12px;
}
</style>
